import { Component, Input } from '@angular/core';
import { Breadcrumb } from '../../../../models/shared/stylesheet/breadcrumb';
import { StatusPill } from '../../../../models/shared/status-pill';

@Component({
  selector: 'app-breadcrumb-header',
  templateUrl: './breadcrumb-header.component.html',
  styleUrls: ['./breadcrumb-header.component.scss']
})
export class BreadcrumbHeaderComponent {
  @Input() breadcrumbs: Breadcrumb[] = [];
  @Input() headerTitle: string = '';
  @Input() isLoading: boolean = false;
  @Input() includeBanner: boolean = false;
  @Input() isSystemBanner: boolean = false;
  @Input() statusPill: StatusPill | null = null;
  @Input() secondaryStatusPill: StatusPill | null = null;
}
